import { StandardProps } from "../../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { GalleryTeaserUI } from "./GalleryTeaserUI";
import { videoPreloadValues } from "@/components/Galleries/utils.ts";
import { parseFlagEnumValue } from "@/utils/flags/parseFlagEnumValue.ts";

type GalleryProps = Pick<StandardProps, "product" | "configProps" | "flags">;

export const GalleryTeaser = ({
  product,
  configProps,
  flags,
}: GalleryProps) => {
  const { variant } = useVariant(product);
  const openModalOnClick = configProps?.openModalOnClick === true;

  const videoPreload = parseFlagEnumValue(
    flags.videoPreload?.value,
    videoPreloadValues,
    "auto",
  );

  return (
    <GalleryTeaserUI
      product={product}
      variant={variant}
      openModalOnClick={openModalOnClick}
      videoPreload={videoPreload}
      carouselGalleryInpTest={flags.carouselGalleryInpTest.value === true}
    />
  );
};
